module.exports = __webpack_public_path__ + "static/img/produce16.6b5cc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce16.png
// module id = 146
// module chunks = 4